<div>
  <div class="dialog-body">
    <div class="dialog-content-description gea-font-body-20">
      Are you sure you want to delete <strong>{{ asset.fileName }}</strong
      >?
    </div>
    <p class="dialog-warning">This will remove the asset from the current workspace.</p>
  </div>
  <div class="p-dialog-footer">
    <geaui-button-v3 [disabled]="isDeleting()" (click)="cancel()" type="secondary">Cancel</geaui-button-v3>
    <geaui-button-v3 [sending]="isDeleting()" [disabled]="isDeleting()" (click)="confirm()" information="error"
      >Delete</geaui-button-v3
    >
  </div>
</div>
